import React from 'react';
import styled from 'styled-components';
import {
  screenXsMax,
  screenMdMin,
  spacer8,
  spacer16,
  spacer20,
  spacer32,
  spacer40,
  spacer56,
} from '@spotify-internal/encore-foundation';

import { HeadlineWithSupertextComponent, ImageAspectBox16x9 } from '../../ui';
import { ShareButtonsComponent as ShareButtons } from '../../ui/ShareButtons';
import { ContentfulAsset } from '../../Contentful';
import { ContentfulImage } from '../../Contentful/ContentfulImage';

const maxWidthOfImage = '984px';
const maxWidthOfText = '660px';

const ArticleHeader = styled.div<{
  backgroundColor: string;
  textColor: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 100px;
  padding-left: ${spacer40};
  padding-right: ${spacer40};
  padding-bottom: ${spacer32};
  color: ${({ textColor }) => textColor};
  background-color: ${({ backgroundColor }) => backgroundColor};

  @media (max-width: ${screenXsMax}) {
    padding: ${spacer56} ${spacer20} ${spacer16} ${spacer20};
  }
`;

const ImageContainer = styled(ImageAspectBox16x9)`
  max-width: ${maxWidthOfImage};
  width: 75%;
  margin: auto;

  @media (max-width: ${screenMdMin}) {
    width: 100%;
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: ${spacer32};
  align-items: center;

  a:last-child {
    padding-right: 0;
  }

  .addthis_toolbox {
    padding-bottom: 0;
  }

  @media (max-width: ${screenXsMax}) {
    justify-content: space-between;
  }
`;

const AuthorDate = styled.div`
  padding-bottom: ${spacer20};
`;

const TextContainer = styled.div`
  max-width: ${maxWidthOfText};
  margin: auto;

  & div > p {
    padding-top: ${spacer20};
  }

  & div > h1 {
    padding-top: ${spacer16};
    text-align: center;
  }
`;

type ArticleHeaderModuleType = {
  textColor?: string;
  backgroundColor?: string;
  headline?: string;
  supertext?: string;
  image: ContentfulAsset;
  authorDateString?: string;
};

export const ArticleHeaderModule: React.FC<ArticleHeaderModuleType> = ({
  headline = '',
  supertext = '',
  image,
  authorDateString = '',
  backgroundColor = '',
  textColor = '',
}) => {
  return (
    <ArticleHeader backgroundColor={backgroundColor} textColor={textColor}>
      <TextContainer>
        <HeadlineWithSupertextComponent
          centered
          headline={headline}
          supertext={supertext}
          text={textColor}
          background={backgroundColor}
        />
      </TextContainer>
      {image && (
        <ImageContainer>
          <ContentfulImage asset={image} />
        </ImageContainer>
      )}
      <Bottom>
        <AuthorDate>{authorDateString}</AuthorDate>
        <ShareButtons textColor={textColor} />
      </Bottom>
    </ArticleHeader>
  );
};
